"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UDynamicService = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * 一个组件的服务
 * 作用： 可以快速在你想要的位置打开一个组件，减少组件show: true false这种写法
 */
var ioc_1 = require("@baidu/ioc");
var bce_helper_1 = require("@baidu/bce-helper");
var ReactDOM = require("react-dom");
var React = require("react");
var version = Number((_a = React === null || React === void 0 ? void 0 : React.version) === null || _a === void 0 ? void 0 : _a.slice(0, 2)) || 18;
var is17 = version < 18;
console.info("react\u73AF\u5883-".concat(version));
var UDynamicService = /** @class */ (function () {
    function UDynamicService() {
        this.nameDivMap = new Map();
        this.divNameMap = new Map();
    }
    UDynamicService.prototype.open = function (options) {
        var Component = options.component;
        var name = Component.name;
        var div = document.createElement('div');
        if (is17) {
            ReactDOM.render(((0, jsx_runtime_1.jsx)(Component, __assign({ id: div }, options.props))), div);
        }
        else {
            Promise.resolve().then(function () { return require('react-dom/client'); }).then(function (_a) {
                var createRoot = _a.createRoot;
                createRoot(div).render((0, jsx_runtime_1.jsx)(Component, __assign({ id: div }, options.props)));
            });
        }
        if (options.selector) {
            options.selector.appendChild(div);
        }
        else {
            document.body.appendChild(div);
        }
        var arrDiv = (this.nameDivMap.get(name) || []);
        arrDiv.push(div);
        this.nameDivMap.set(name, arrDiv);
        this.divNameMap.set(div, name);
        return div;
    };
    UDynamicService.prototype.destroyedEleAndCom = function (ele) {
        if (is17) {
            ReactDOM.unmountComponentAtNode(ele);
        }
        ele.remove();
    };
    UDynamicService.prototype.removeDivFormMap = function (name, ele) {
        this.divNameMap.delete(ele);
        var divArr = this.nameDivMap.get(name) || [];
        if (divArr.length > 0) {
            (0, bce_helper_1.removeFromArrayByCondition)(divArr, function (item) {
                return item === ele;
            });
        }
    };
    UDynamicService.prototype.destroyed = function (ele, isDeleteOtherSameCom) {
        var _this = this;
        setTimeout(function () {
            var name = _this.divNameMap.get(ele);
            if (isDeleteOtherSameCom) {
                var divArr = _this.nameDivMap.has(name) ? _this.nameDivMap.get(name) : [];
                while (divArr.length > 0) {
                    _this.destroyedEleAndCom(divArr[0]);
                    _this.removeDivFormMap(name, divArr[0]);
                }
            }
            else {
                _this.destroyedEleAndCom(ele);
                _this.removeDivFormMap(name, ele);
            }
        }, 300);
    };
    UDynamicService = __decorate([
        (0, ioc_1.Injectable)()
    ], UDynamicService);
    return UDynamicService;
}());
exports.UDynamicService = UDynamicService;
